import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../service/http.service';
import { Booking } from '../booking';

@Component({
  selector: 'app-booking-detail',
  templateUrl: './booking-detail.component.html',
  styleUrls: ['./booking-detail.component.css']
})
export class BookingDetailComponent implements OnInit {

  booking!: Booking;
  showPicture: any;
  pictureLoaded: boolean = false;
  fileToUpload: File | null = null;
  url!: string;

  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService
  ) { }

  ngOnInit() {
    let uuid = this.route.snapshot.paramMap.get("uuid")!;
    this.httpService.getBookingByUuid(uuid)
    .subscribe(booking => {
      this.booking = booking;
      this.httpService.getStudentPictureByUuid(uuid)
      .subscribe(picture => {
        let reader = new FileReader();
        reader.addEventListener("load", () => {
          this.showPicture = reader.result;
       }, false);
       if (picture) {
        reader.readAsDataURL(picture);
     }
        this.pictureLoaded = true;
      },
      error => console.error(error)
      );
    },
    error => console.error(error)
    );
  }

  handleFileInput(event: any){
    if(event.target.files && event.target.files[0]){
      this.fileToUpload = event.target.files[0];
      let reader = new FileReader();
      reader.onload = (event: any) => this.url = event.target.result;
      reader.readAsDataURL(event.target.files[0]);
    }
  }
}
